/* eslint-disable no-param-reassign */

export default {
  toggleCopySettingsPopup(state, flag) {
    state.isOpenCopyPopup = flag;
  },
  hasCopiedTask(state, flag) {
    state.hasCopiedTask = flag;
  },
  setCopiedTask(state, data) {
    state.copiedTask = data;
  },
  assignCopyData(state, payload) {
    const data = state.copiedTask ? { ...state.copiedTask, ...payload } : { ...payload };

    state.copiedTask = { ...data };
  },
  setCopySettingsConfig(state, config) {
    state.copySettingsConfigsMap[config.project_id] = config;
  },
  setCurrentProjectId(state, id) {
    state.currentProjectId = id;
  },
  updateConfig(state, { projectId, updated }) {
    state.copySettingsConfigsMap[projectId].settings = updated.settings
  },
  setTaskMap(state, data) {
    state.taskMap = data;
  },
  resetStore(state) {
    state.hasCopiedTask = false;
    state.copiedTask = null;
    state.copySettingsConfigsMap = {};
  },
  insertingProcess(state, { flag }) {
    state.isInsertingProcess = flag;
  },
  setCopyPastError(state, text) {
    state.copyPastError = text;
  },
};
